import React, { FC } from 'react';
import InputMask from 'react-input-mask';
import Input from '../Input';
import { Props } from './interfaces';

export const MaskedInput: FC<Props> = (props) => (
  <InputMask {...props} maskPlaceholder={null}>
    <Input {...props} />
  </InputMask>
);

export default MaskedInput;
